import { CreateLikeDto } from '../../common/dto/CreateLikeDto';
import { createAppAsyncThunk } from '../../store/extensions';
import { CreatePostDto } from './dtos/CreatePostDto';
import { ExternalUrlDto } from './dtos/ExternalUrlDto';
import { UpdatePostDto } from './dtos/UpdatePostDto';
import { ModeratorEditPostDto } from './models';
import {
  createPostCall,
  createPostInMultipleRoomsCall,
  deletePostCall,
  fetchFeedPostsByTopicsCall,
  fetchFeedPostsCall,
  fetchMyRoomsFeedPostsCall,
  fetchOpenGraphMetaTagsCall,
  fetchPostCall,
  fetchRoomPostsCall,
  moderatorDeletePostCall,
  moderatorEditPostCall,
  movePostToAnotherRoomCall,
  pinPostToRoomCall,
  reportPostCall,
  unpinPostFromRoomCall,
  updatePostCall,
  updatePostLikeCall,
} from './service';

export const fetchRoomPosts = createAppAsyncThunk(
  'community/room/posts/getAll',
  (args: {
    roomId: string;
    xMsContinuationToken?: string;
    numrecs?: number;
  }) => {
    return fetchRoomPostsCall(
      args.roomId,
      args.xMsContinuationToken,
      args.numrecs
    );
  }
);

export const createPost = createAppAsyncThunk(
  'community/posts/createPost',
  (args: { newPost: CreatePostDto; roomId: string }) => {
    return createPostCall(args.newPost, args.roomId);
  }
);

export const createPostInMultipleRooms = createAppAsyncThunk(
  'community/posts/createPostInMultipleRooms',
  (args: { newPost: CreatePostDto }) => {
    return createPostInMultipleRoomsCall(args.newPost);
  }
);

export const updatePost = createAppAsyncThunk(
  'community/posts/updatePost',
  (args: { updatedPost: UpdatePostDto; postId: string }) => {
    return updatePostCall(args.updatedPost, args.postId);
  }
);

export const deletePost = createAppAsyncThunk(
  'community/posts/deletePost',
  (postId: string) => {
    return deletePostCall(postId);
  }
);

export const fetchFeedPosts = createAppAsyncThunk(
  'community/posts/feed',
  (args: { xMsContinuationToken?: string; numrecs?: number }) => {
    return fetchFeedPostsCall(args.xMsContinuationToken, args.numrecs);
  }
);

export const updatePostLike = createAppAsyncThunk(
  'community/post/like',
  (args: { like: CreateLikeDto; roomId: string; postId: string }) => {
    return updatePostLikeCall(args.like, args.roomId, args.postId);
  }
);

export const fetchPost = createAppAsyncThunk(
  'community/room/post/get',
  (postId: string) => {
    return fetchPostCall(postId);
  }
);

export const reportPost = createAppAsyncThunk(
  'community/post/report',
  (postId: string) => {
    return reportPostCall(postId);
  }
);

export const moderatorDeletePost = createAppAsyncThunk(
  'community/moderator/deletePost',
  (postId: string) => {
    return moderatorDeletePostCall(postId);
  }
);

export const moderatorEditPost = createAppAsyncThunk(
  'community/moderator/editPost',
  (args: { postId: string; editPostDto: ModeratorEditPostDto }) => {
    return moderatorEditPostCall(args.postId, args.editPostDto);
  }
);

export const moderatorPinPost = createAppAsyncThunk(
  'stories/moderator/pinPost',
  (args: { postId: string }) => {
    return pinPostToRoomCall(args.postId);
  }
);

export const moderatorUnpinPost = createAppAsyncThunk(
  'stories/moderator/unpinPost',
  (args: { postId: string }) => {
    return unpinPostFromRoomCall(args.postId);
  }
);

export const fetchOpenGraphMetaTags = createAppAsyncThunk(
  'community/openGraphMetaTags/get',
  (url: ExternalUrlDto) => {
    return fetchOpenGraphMetaTagsCall(url);
  }
);

export const fetchMyRoomsFeedPosts = createAppAsyncThunk(
  'community/myRooms/posts/getAll',
  (args: {
    xMsContinuationToken?: string;
    numrecs?: number;
    isOnMobile?: boolean;
  }) => {
    return fetchMyRoomsFeedPostsCall(args.xMsContinuationToken, args.numrecs);
  }
);

export const fetchFeedPostsByTopics = createAppAsyncThunk(
  'community/topics/posts/getAll',
  (args: {
    topics: { topics: string[] };
    xMsContinuationToken?: string;
    numrecs?: number;
  }) => {
    return fetchFeedPostsByTopicsCall(
      args.topics,
      args.xMsContinuationToken,
      args.numrecs
    );
  }
);

export const movePostToAnotherRoom = createAppAsyncThunk(
  'community/moderator/posts/movePost',
  (args: { postId: string; roomId: string }) => {
    return movePostToAnotherRoomCall(args.postId, args.roomId);
  }
);
